import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { callOpenRouter } from '../utils/api.js';
import {
  Bot, X, Send, Sparkles,
  Zap, Globe, Wifi, CreditCard, MessageCircle,
  MapPin, Mail, Phone, Music, FileText, User,
  ChevronRight, ArrowLeft
} from 'lucide-react';

// ── Brand SVG icons (lucide has no brand icons) ───────────────
const WhatsAppIcon = ({ size = 18, color = '#25D366' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const YoutubeIcon = ({ size = 18, color = '#FF0000' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const InstagramIcon = ({ size = 18, color = '#833AB4' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

const FacebookIcon = ({ size = 18, color = '#1877F2' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const LinkedinIcon = ({ size = 18, color = '#0A66C2' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const TwitterIcon = ({ size = 18, color = '#000000' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const SpotifyIcon = ({ size = 18, color = '#1DB954' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);
import styles from './QRSuggester.module.css';

// const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;
// const OPENROUTER_URL     = 'https://openrouter.ai/api/v1/chat/completions';

// ── Site features the AI knows about ────────────────────────
const SITE_CONTEXT = `
SimplifyQR (simplifyqr.com) is a FREE QR code generator with ZERO watermark.

AVAILABLE QR TYPES on this website:
- upi       → UPI Payment QR (works with GPay, PhonePe, Paytm, BHIM — India only)
- url        → Any website link or URL
- whatsapp   → WhatsApp chat link with pre-filled message
- wifi       → WiFi password sharing (scan to connect)
- youtube    → YouTube channel or video link
- instagram  → Instagram profile link
- facebook   → Facebook page/profile link
- spotify    → Spotify song, album, playlist
- vcard      → Digital business card (contact info)
- email      → Email with pre-filled subject and body
- phone      → Phone number (tap to call)
- location   → Google Maps location pin
- linkedin   → LinkedIn profile
- twitter    → Twitter/X profile
- sms        → SMS with pre-filled message
- text       → Plain text


SPECIAL FEATURES:
- All QR codes are FREE with NO watermark
- Download as PNG, JPG, SVG
- Custom colors and branded QR codes (platform-themed colors)
- Logo upload in center of QR
- Transparent background option
- Print-ready format
- WhatsApp share
- AI quality checker scores your QR 0–100
- Live scan test (checks if QR actually works before download)
- UPI QR with amount and note pre-filled
- WiFi QR — customers just scan to connect, no typing password
- vCard QR — complete digital business card that saves to contacts app

OTHER TOOLS on simplifyqr.com:
- /qr-code-scanner-online → Scan QR codes from camera or image
- /scan-qr-code-from-image → Upload image and decode QR
- /free-qr-code-generator-india → India-focused QR generator
- /qr-card-creator → QR Card Creator: make a printable business card or poster with QR. Use type "qrcard"
- /story-creator → Story Creator: make Instagram/WhatsApp story with QR code. Use type "story"
- /upi-qr-code-generator → Dedicated UPI payment QR page
- /wifi-qr-code-generator → Dedicated WiFi QR page
- /whatsapp-qr-code-generator → Dedicated WhatsApp QR page
- /google-pay-qr-code-generator → Google Pay specific QR
`;

// ── Language config ──────────────────────────────────────────
const LANGUAGES = [
  { code: 'en',       label: 'English',  flag: '🇬🇧' },
  { code: 'hi',       label: 'हिंदी',    flag: '🇮🇳' },
  { code: 'hinglish', label: 'Hinglish', flag: '🔀'  },
];

const UI_TEXT = {
  en: {
    greeting:    'Hi! I\'m your QR assistant 👋',
    question:    'Tell me about your business or what you need a QR code for:',
    placeholder: 'e.g. I have a bakery in Delhi and want customers to pay easily...',
    or:          'Quick options',
    reset:       'Ask something else',
    title:       'QR Assistant',
    poweredBy:   'AI powered · Free',
    generate:    'Generate',
    loading:     'Finding best QR codes for you...',
    floatLabel:  'Need help?',
  },
  hi: {
    greeting:    'नमस्ते! मैं आपका QR असिस्टेंट हूं 👋',
    question:    'अपना बिजनेस या जरूरत बताएं:',
    placeholder: 'जैसे: मेरी दिल्ली में बेकरी है और ग्राहकों को पेमेंट आसान बनाना है...',
    or:          'जल्दी चुनें',
    reset:       'कुछ और पूछें',
    title:       'QR असिस्टेंट',
    poweredBy:   'AI संचालित · मुफ्त',
    generate:    'बनाएं',
    loading:     'आपके लिए सबसे अच्छे QR ढूंढ रहे हैं...',
    floatLabel:  'मदद चाहिए?',
  },
  hinglish: {
    greeting:    'Namaste! Main aapka QR assistant hoon 👋',
    question:    'Batao apna business ya zaroorat:',
    placeholder: 'e.g. Meri Delhi mein bakery hai aur customers ko payment easy banana hai...',
    or:          'Quick options',
    reset:       'Kuch aur pucho',
    title:       'QR Assistant',
    poweredBy:   'AI powered · Free',
    generate:    'Banao',
    loading:     'Aapke liye best QR dhundh rahe hain...',
    floatLabel:  'Help chahiye?',
  },
};

const QUICK_OPTIONS = {
  en: [
    { icon: '🏪', label: 'Shop / Kirana',     value: 'I have a small kirana shop or retail store' },
    { icon: '🍽️', label: 'Restaurant / Cafe', value: 'I run a restaurant, cafe or dhaba' },
    { icon: '👨‍💻', label: 'Freelancer / Pro',  value: 'I am a freelancer or self-employed professional' },
    { icon: '🎓', label: 'Student / Event',   value: 'I am a student organizing a college event' },
    { icon: '🏠', label: 'Home / Personal',   value: 'I need a QR code for personal home use' },
    { icon: '📦', label: 'Office / Business', value: 'I run a business or corporate office' },
  ],
  hi: [
    { icon: '🏪', label: 'दुकान / किराना',    value: 'मेरी एक छोटी दुकान है' },
    { icon: '🍽️', label: 'रेस्टोरेंट / ढाबा', value: 'मेरा एक रेस्टोरेंट या ढाबा है' },
    { icon: '👨‍💻', label: 'फ्रीलांसर',          value: 'मैं एक फ्रीलांसर हूं' },
    { icon: '🎓', label: 'छात्र / कॉलेज',      value: 'मैं एक छात्र हूं' },
    { icon: '🏠', label: 'घर / व्यक्तिगत',     value: 'घर के लिए QR चाहिए' },
    { icon: '📦', label: 'बिजनेस / ऑफिस',     value: 'मैं एक बिजनेस चलाता हूं' },
  ],
  hinglish: [
    { icon: '🏪', label: 'Shop / Kirana',     value: 'Meri ek choti si shop hai' },
    { icon: '🍽️', label: 'Restaurant',        value: 'Mera ek restaurant ya dhaba hai' },
    { icon: '👨‍💻', label: 'Freelancer',         value: 'Main ek freelancer hoon' },
    { icon: '🎓', label: 'Student',           value: 'Main student hoon' },
    { icon: '🏠', label: 'Ghar',              value: 'Ghar ke liye QR chahiye' },
    { icon: '📦', label: 'Business',          value: 'Main ek business chalata hoon' },
  ],
};

// ── QR type registry ──────────────────────────────────────────
const QR_TYPES = {
  story: { label: 'Story Creator', icon: Globe, color: '#833AB4', bg: '#faf5ff' },
    qrcard:    { label: 'QR Card Creator',  icon: CreditCard,    color: '#1D9E75', bg: '#f0fdf4' },

  upi:       { label: 'UPI Payment',    icon: CreditCard,    color: '#ea580c', bg: '#fff7ed' },
  url:       { label: 'Website URL',    icon: Globe,         color: '#534AB7', bg: '#f5f3ff' },
  whatsapp:  { label: 'WhatsApp',       icon: WhatsAppIcon,  color: '#25D366', bg: '#f0fdf4' },
  wifi:      { label: 'WiFi Password',  icon: Wifi,          color: '#0ea5e9', bg: '#f0f9ff' },
  youtube:   { label: 'YouTube',        icon: YoutubeIcon,   color: '#FF0000', bg: '#fff0f0' },
  instagram: { label: 'Instagram',      icon: InstagramIcon, color: '#833AB4', bg: '#faf5ff' },
  facebook:  { label: 'Facebook',       icon: FacebookIcon,  color: '#1877F2', bg: '#eff6ff' },
  spotify:   { label: 'Spotify',        icon: SpotifyIcon,   color: '#1DB954', bg: '#f0fdf4' },
  vcard:     { label: 'Business Card',  icon: User,          color: '#534AB7', bg: '#f5f3ff' },
  email:     { label: 'Email',          icon: Mail,          color: '#534AB7', bg: '#f5f3ff' },
  phone:     { label: 'Phone Number',   icon: Phone,         color: '#1D9E75', bg: '#f0fdf4' },
  location:  { label: 'Location',       icon: MapPin,        color: '#e11d48', bg: '#fff1f2' },
  linkedin:  { label: 'LinkedIn',       icon: LinkedinIcon,  color: '#0A66C2', bg: '#eff6ff' },
  twitter:   { label: 'Twitter / X',    icon: TwitterIcon,   color: '#000000', bg: '#f9fafb' },
  sms:       { label: 'SMS Message',    icon: MessageCircle, color: '#534AB7', bg: '#f5f3ff' },
  text:      { label: 'Plain Text',     icon: FileText,      color: '#534AB7', bg: '#f5f3ff' },
};

// ── System prompt ────────────────────────────────────────────
function getSystemPrompt(lang) {
  const langInstructions = {
    en:       'Respond ONLY in clear, simple English.',
    hi:       'केवल सरल हिंदी में जवाब दें।',
    hinglish: 'Respond in friendly Hinglish (mix of Hindi and English).',
  };
  return `You are a helpful QR code expert assistant for SimplifyQR.

${SITE_CONTEXT}

${langInstructions[lang]}

RULES:
1. Always suggest 2-3 most relevant QR types from the list above ONLY
2. For each suggestion explain WHY it helps their specific use case
3. If user asks about a feature, explain it exists on the site
4. If user asks "how to use" or about scanning — give a helpful explanation
5. Keep reasons short (1 line max)
6. Do NOT suggest external tools or websites — everything is on SimplifyQR
7. If user wants a business card or printable card → suggest type "qrcard"
8. If user wants Instagram/WhatsApp story with QR → suggest type "story"
9. If unsure, default to: upi, whatsapp, url

RESPOND IN THIS EXACT JSON FORMAT (no other text):
{
  "greeting": "One friendly line acknowledging their need",
  "explanation": "One sentence about what you're recommending and why (optional, can be null)",
  "suggestions": [
    {
      "type": "upi",
      "reason": "Short specific reason for their use case"
    }
  ]
}`;
}

// ── Smart local fallback ──────────────────────────────────────
function getFallback(message, lang) {
  const t = message.toLowerCase();
  const isHi = lang === 'hi';

  if (t.includes('restaurant') || t.includes('dhaba') || t.includes('cafe') || t.includes('bakery') || t.includes('hotel') || t.includes('रेस्टोरेंट') || t.includes('ढाबा')) {
    return {
      greeting:    isHi ? 'आपके बिजनेस के लिए बढ़िया विकल्प! 🍽️' : 'Great choices for your food business! 🍽️',
      explanation: isHi ? 'ये तीन QR आपके restaurant/cafe के लिए सबसे ज़्यादा useful हैं।' : 'These 3 QR codes are most useful for restaurants and cafes.',
      suggestions: [
        { type: 'upi',      reason: isHi ? 'GPay, Paytm, PhonePe से instant payment' : 'Accept GPay, PhonePe, Paytm payments instantly' },
        { type: 'wifi',     reason: isHi ? 'Customers password बिना WiFi connect करें' : 'Customers connect to WiFi without typing password' },
        { type: 'whatsapp', reason: isHi ? 'Order और inquiry के लिए direct contact' : 'Direct WhatsApp for orders and inquiries' },
      ],
    };
  }
  if (t.includes('shop') || t.includes('kirana') || t.includes('store') || t.includes('दुकान') || t.includes('किराना')) {
    return {
      greeting:    isHi ? 'आपकी दुकान के लिए QR! 🏪' : 'Perfect QR codes for your shop! 🏪',
      explanation: null,
      suggestions: [
        { type: 'upi',      reason: isHi ? 'Cash की जगह digital payment' : 'Accept digital payments instead of cash' },
        { type: 'whatsapp', reason: isHi ? 'Customers order और enquiry कर सकें' : 'Customers can place orders via WhatsApp' },
        { type: 'url',      reason: isHi ? 'Google Maps या website का link' : 'Link to Google Maps or your website' },
      ],
    };
  }
  if (t.includes('freelancer') || t.includes('developer') || t.includes('designer') || t.includes('फ्रीलांसर')) {
    return {
      greeting:    isHi ? 'Freelancers के लिए best QR! 👨‍💻' : 'Best QR codes for freelancers! 👨‍💻',
      explanation: null,
      suggestions: [
        { type: 'vcard',    reason: isHi ? 'Client को digital business card share करें' : 'Share your digital business card with clients' },
        { type: 'linkedin', reason: isHi ? 'Professional profile को link करें' : 'Link your LinkedIn profile' },
        { type: 'whatsapp', reason: isHi ? 'Clients directly contact कर सकें' : 'Clients can contact you directly' },
      ],
    };
  }
  if (t.includes('office') || t.includes('business') || t.includes('corporate') || t.includes('बिजनेस')) {
    return {
      greeting:    isHi ? 'Business के लिए QR solutions! 📦' : 'QR solutions for your business! 📦',
      explanation: null,
      suggestions: [
        { type: 'vcard',    reason: isHi ? 'Digital business card networking events के लिए' : 'Digital business cards for networking' },
        { type: 'wifi',     reason: isHi ? 'Office WiFi share करना easy' : 'Easy office WiFi sharing for guests' },
        { type: 'url',      reason: isHi ? 'Company website या landing page' : 'Link to company website or landing page' },
      ],
    };
  }
  if (t.includes('payment') || t.includes('pay') || t.includes('upi') || t.includes('paytm') || t.includes('gpay') || t.includes('पेमेंट')) {
    return {
      greeting:    isHi ? 'Payment के लिए QR! 💳' : 'Payment QR code ready! 💳',
      explanation: isHi ? 'UPI QR से GPay, PhonePe, Paytm, BHIM सब accept होता है।' : 'UPI QR accepts GPay, PhonePe, Paytm and all UPI apps.',
      suggestions: [
        { type: 'upi', reason: isHi ? 'सभी UPI apps support — free, no charges' : 'Works with all UPI apps — completely free' },
      ],
    };
  }
  // default
  return {
    greeting:    isHi ? 'ये QR codes आपके काम आ सकते हैं 👇' : 'Here are some QR codes that might help you 👇',
    explanation: null,
    suggestions: [
      { type: 'upi',      reason: isHi ? 'Digital payment accept करें' : 'Accept digital payments' },
      { type: 'whatsapp', reason: isHi ? 'Direct customer contact' : 'Direct customer communication' },
      { type: 'url',      reason: isHi ? 'Website या social media link' : 'Link to website or social media' },
    ],
  };
}

// ── Main Component ────────────────────────────────────────────
export default function QRSuggester() {
  const [isOpen,  setIsOpen]  = useState(false);
  const [step,    setStep]    = useState('options');
  const [input,   setInput]   = useState('');
  const [result,  setResult]  = useState(null);
  const [lang,    setLang]    = useState('en');
  const [pulse,   setPulse]   = useState(false);
  const chatRef  = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const ui       = UI_TEXT[lang];

  // Pulse animation every 5s when closed
  useEffect(() => {
    if (isOpen) return;
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 1000);
    }, 5000);
    return () => clearInterval(interval);
  }, [isOpen]);

  useEffect(() => {
    if (chatRef.current) chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [step, result]);

  useEffect(() => {
    if ((step === 'options' || step === 'typing') && inputRef.current) inputRef.current.focus();
  }, [step, isOpen]);

  useEffect(() => {
    setStep('options'); setResult(null); setInput('');
  }, [lang]);

 const askAI = async (userMessage) => {
  const clean = userMessage.trim();
  if (!clean) return;
  setStep('loading');

  try {
    const text = await callOpenRouter({
      messages: [
        { role: 'system', content: getSystemPrompt(lang) },
        { role: 'user',   content: clean },
      ],
      max_tokens: 300,
      response_format: { type: 'json_object' },
    });

    if (!text) throw new Error('No response');

    let parsed;
    try { parsed = JSON.parse(text); }
    catch { const m = text.match(/\{[\s\S]*\}/); parsed = m ? JSON.parse(m[0]) : null; }

    if (!parsed?.suggestions?.length) throw new Error('Invalid');
    setResult(parsed);
    setStep('result');
  } catch {
    setResult(getFallback(clean, lang));
    setStep('result');
  }
};
  const handleGenerate = (qrType) => {
    setIsOpen(false); setStep('options'); setResult(null); setInput('');
    localStorage.setItem('simplifyqr_qr_type', qrType);
    window.dispatchEvent(new CustomEvent('setQRType', { detail: qrType }));
    navigate('/');
    setTimeout(() => document.getElementById('tool')?.scrollIntoView({ behavior: 'smooth' }), 200);
  };

  const handleClose = () => { setIsOpen(false); setStep('options'); setResult(null); setInput(''); };
  const handleReset = () => { setStep('options'); setResult(null); setInput(''); };

  return (
    <>
      {/* ── FLOATING BUTTON ── */}
      <button
        className={`${styles.floatBtn} ${isOpen ? styles.floatBtnOpen : ''} ${pulse && !isOpen ? styles.floatBtnPulse : ''}`}
        onClick={() => isOpen ? handleClose() : setIsOpen(true)}
        aria-label="QR Assistant"
      >
        {isOpen ? (
          <X size={16} strokeWidth={2.5} />
        ) : (
          <>
            <div className={styles.floatBtnInner}>
              <Bot size={18} strokeWidth={2} />
              <span className={styles.floatLabel}>{ui.floatLabel}</span>
            </div>
            <span className={styles.floatPing} />
          </>
        )}
      </button>

      {/* ── CHAT PANEL ── */}
      {isOpen && (
        <div className={styles.chat}>

          {/* Header */}
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <div className={styles.avatar}>
                <Bot size={17} strokeWidth={2} />
                <span className={styles.avatarDot} />
              </div>
              <div>
                <div className={styles.headerTitle}>{ui.title}</div>
                <div className={styles.headerSub}>
                  <Sparkles size={10} />
                  <span>{ui.poweredBy}</span>
                </div>
              </div>
            </div>
            <div className={styles.headerRight}>
              {LANGUAGES.map(l => (
                <button
                  key={l.code}
                  className={`${styles.langBtn} ${lang === l.code ? styles.langBtnOn : ''}`}
                  onClick={() => setLang(l.code)}
                  title={l.label}
                >
                  {l.flag}
                </button>
              ))}
              <button className={styles.closeBtn} onClick={handleClose}>
                <X size={14} />
              </button>
            </div>
          </div>

          {/* Body */}
          <div className={styles.body} ref={chatRef}>

            {/* OPTIONS / TYPING */}
            {(step === 'options' || step === 'typing') && (
              <div className={styles.optionsWrap}>
                {/* Greeting bubble */}
                <div className={styles.botBubble}>
                  <div className={styles.botBubbleInner}>
                    <p className={styles.greeting}>{ui.greeting}</p>
                    <p className={styles.question}>{ui.question}</p>
                  </div>
                </div>

                {/* Quick options */}
                <div className={styles.quickLabel}>
                  <Zap size={11} />
                  <span>{ui.or}</span>
                </div>
                <div className={styles.quickGrid}>
                  {QUICK_OPTIONS[lang].map(opt => (
                    <button
                      key={opt.value}
                      className={styles.quickBtn}
                      onClick={() => { setInput(opt.value); askAI(opt.value); }}
                    >
                      <span className={styles.quickIcon}>{opt.icon}</span>
                      <span className={styles.quickLabel2}>{opt.label}</span>
                      <ChevronRight size={11} className={styles.quickArrow} />
                    </button>
                  ))}
                </div>

                {/* Custom input */}
                <div className={styles.inputWrap}>
                  <input
                    ref={inputRef}
                    className={styles.input}
                    placeholder={ui.placeholder}
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && input.trim() && askAI(input.trim())}
                    onFocus={() => setStep('typing')}
                  />
                  <button
                    className={`${styles.sendBtn} ${input.trim() ? styles.sendBtnActive : ''}`}
                    onClick={() => input.trim() && askAI(input.trim())}
                    disabled={!input.trim()}
                  >
                    <Send size={14} strokeWidth={2.5} />
                  </button>
                </div>
              </div>
            )}

            {/* LOADING */}
            {step === 'loading' && (
              <div className={styles.loadingWrap}>
                <div className={styles.botBubble}>
                  <div className={styles.botBubbleInner}>
                    <p className={styles.loadingText}>{ui.loading}</p>
                  </div>
                </div>
                <div className={styles.dots}>
                  <span /><span /><span />
                </div>
              </div>
            )}

            {/* RESULT */}
            {step === 'result' && result && (
              <div className={styles.resultWrap}>
                {/* AI greeting */}
                <div className={styles.botBubble}>
                  <div className={styles.botBubbleInner}>
                    <p className={styles.resultGreeting}>{result.greeting}</p>
                    {result.explanation && (
                      <p className={styles.resultExplanation}>{result.explanation}</p>
                    )}
                  </div>
                </div>

                {/* Suggestion cards */}
                <div className={styles.cards}>
                  {result.suggestions?.map((s, i) => {
                    const qr = QR_TYPES[s.type];
                    if (!qr) return null;
                    const Icon = qr.icon;
                    return (
                      <div key={i} className={styles.card} style={{ '--card-color': qr.color, '--card-bg': qr.bg }}>
                        <div className={styles.cardTop}>
                          <div className={styles.cardIcon} style={{ background: qr.bg }}>
                            <Icon size={18} color={qr.color} strokeWidth={2} />
                          </div>
                          <div className={styles.cardInfo}>
                            <div className={styles.cardName}>{qr.label}</div>
                            <div className={styles.cardReason}>{s.reason}</div>
                          </div>
                        </div>
                        <button
                          className={styles.cardBtn}
                          style={{ background: qr.color }}
                          onClick={() => handleGenerate(s.type)}
                        >
                          <Sparkles size={12} />
                          <span>{ui.generate} {qr.label} QR</span>
                          <ChevronRight size={13} />
                        </button>
                      </div>
                    );
                  })}
                </div>

                {/* Follow-up input */}
<div className={styles.inputWrap} style={{ marginTop: '4px' }}>
  <input
    className={styles.input}
    placeholder="Ask something else..."
    value={input}
    onChange={e => setInput(e.target.value)}
    onKeyDown={e => e.key === 'Enter' && input.trim() && askAI(input.trim())}
  />
  <button
    className={`${styles.sendBtn} ${input.trim() ? styles.sendBtnActive : ''}`}
    onClick={() => input.trim() && askAI(input.trim())}
    disabled={!input.trim()}
  >
    <Send size={14} strokeWidth={2.5} />
  </button>
</div>
                {/* Reset */}
                <button className={styles.resetBtn} onClick={handleReset}>
                  <ArrowLeft size={13} />
                  <span>{ui.reset}</span>
                </button>
              </div>
            )}

          </div>
        </div>
      )}
    </>
  );
}